import { render, staticRenderFns } from "./InfoPlan.vue?vue&type=template&id=2b515916"
import script from "./InfoPlan.vue?vue&type=script&lang=js"
export * from "./InfoPlan.vue?vue&type=script&lang=js"
import style0 from "./InfoPlan.vue?vue&type=style&index=0&id=2b515916&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports